import React, { useCallback, useEffect, useState } from "react";
import { serviceSideEffectsDetail } from "../../../services/ReportedSideEffects.service";
import { useParams } from "react-router";


function useReportedSideEffectDetailHook() {
  const [data, setData] = useState({});
  const { id } = useParams();
  useEffect(() => {
    if (id) {
        serviceSideEffectsDetail({ id }).then((res) => {
        if (!res?.error) {
          const response = res?.data?.details;
          setData(response);
        }
      });
    }
  }, [id]);

 


  return {
    data,

  };
}

export default useReportedSideEffectDetailHook;
